import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Alert, Spin } from "components/common";
import { callGetApiWithAuth } from "utils/api";

export default function AlertSection() {
  const [lastQVDate, setLastQVDate] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const onGetData = (res) => {
    setIsLoading(false);
    setLastQVDate(res.data.qv_date);
  };
  const onFailData = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    callGetApiWithAuth(`dashboard/pv_date`, onGetData, onFailData);
  }, []);

  return (
    <Wrapper>
      {isLoading ? (
        <div clasName="loadingRoot">
          <Spin spinning={true} />
        </div>
      ) : lastQVDate ? (
        <h6>
          Volume for rank qualification updates every 20 minutes. Current
          Volume is updated at{" "}
          <span style={{ color: "#0abab5" }}>
            <i>{lastQVDate} PST</i>
          </span>
        </h6>
      ) : (
        ""
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .loadingRoot {
    display: flex;
    width: 100%;
    height: 200px;
    justify-content: center;
    align-items: center;
  }
`;
